import React, { useEffect, useState } from "react";
import { Modal, ModalBody } from "react-bootstrap";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import SelectCustomField from "../../form/selectField/selectCustomField";
import { useDispatch } from "react-redux";
import {
  addCustomerProduct,
  customerAddProductList,
  customerAddProductOfferList,
} from "../../../redux/actions/customerActions";
import ChangeSaved from "../../popups/ChangeSaved";
import ErrorPopup from "../../popups/ErrorPopup";
import { AdminButton } from "../../buttons/versionHistoryBtn";
import { useParams } from "react-router-dom";

const AddProductModal = ({ show, ShowClose, divisionList, state_id }) => {
  const dispatch = useDispatch();
  const params = useParams();
  const [divisionId, setDivisionId] = useState("");
  const [productId, setProductId] = useState("");
  const [productList, setProductList] = useState([]);
  const [productOfferList, setProductOfferList] = useState([]);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState();
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState();

  useEffect(() => {
    if (divisionId) {
      dispatch(
        customerAddProductList(
          { division_id: divisionId },
          onProductListSuccess,
          onProductListError
        )
      );
    }
  }, [divisionId]);

  useEffect(() => {
    if (productId) {
      dispatch(
        customerAddProductOfferList(
          { product_id: productId, state_id: state_id },
          onProductOfferListSuccess,
          onProductOfferListError
        )
      );
    }
  }, [productId]);

  const onProductListSuccess = (data) => {
    console.log(data.data.data.products);
    let productArray = data.data.data.products.map((ele) => ({
      value: ele?.id,
      label: ele?.product_name,
    }));
    setProductList(productArray);
  };
  const onProductListError = (err) => {
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
    setShowErrorPopup(true);
  };

  const onProductOfferListSuccess = (data) => {
    console.log(data.data.data.products);
    let productOfferArray = data.data.data.offers.map((ele) => ({
      value: ele?.id,
      label:
        ele?.offer_type === "quantity"
          ? `${ele?.offer} + ${ele?.offer_qty}`
          : ele.after_off,
    }));
    setProductOfferList(productOfferArray);
  };

  const onProductOfferListError = (err) => {
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
    setShowErrorPopup(true);
  };

  const initialValues = {
    division_id: "",
    offer_id: "",
    product_id: "",
  };
  const validationSchema = Yup.object().shape({
    division_id: Yup.string().required("Required"),
  });
  const onSubmit = (values) => {
    console.log(values);
    dispatch(
      addCustomerProduct(
        { doctor_id: params?.id, offer_id: values.offer_id },
        onSuccess,
        onError
      )
    );
  };

  const timeOutFnc = () => {
    setShowSuccessPopup(false);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onSuccess = (data) => {
    ShowClose();
    setShowSuccessPopup(true);
    const str = data.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowSuccessMsg(str_modify);
    setTimeout(timeOutFnc, 2000);
  };
  const onError = (err) => {
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
    setShowErrorPopup(true);
  };
  return (
    <>
      <Modal
        centered
        show={show}
        onHide={ShowClose}
        contentClassName="link-modal col-5 mx-auto p-2 fn_Nunito"
      >
        <ModalBody>
          <div className="m-2">
            <div className="fn_Nunito fs_18 mt-3 ms-2 fw_900">
              <h2 className="fn_Nunito fs_18 mt-3 ms-2 fw_700">ADD PRODUCT</h2>
            </div>

            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
              enableReinitialize={true}
            >
              {({ setFieldValue, values }) => (
                <Form>
                  <div className="py-4">
                    <div className="w-100">
                      <SelectCustomField
                        label={"Divisions"}
                        labelColor={"color_262c3d"}
                        placeholder={"Select Divisions"}
                        optionList={divisionList}
                        name={"division_id"}
                        id={"division_id"}
                        menuHeight="130px"
                        onChange={(selected) => {
                          setFieldValue("division_id", selected);
                          setDivisionId(selected);
                        }}
                        value={divisionList?.find(
                          (item) => item.value === values.division_id
                        )}
                      />
                    </div>
                    <div className="w-100">
                      <SelectCustomField
                        label={"Products"}
                        labelColor={"color_262c3d"}
                        placeholder={"Select Divisions"}
                        optionList={productList}
                        name={"product_id"}
                        id={"product_id"}
                        menuHeight="130px"
                        onChange={(selected) => {
                          setFieldValue("product_id", selected);
                          setProductId(selected);
                        }}
                        value={productList?.find(
                          (item) => item.value === values.product_id
                        )}
                      />
                    </div>
                    <div className="w-100">
                      <SelectCustomField
                        label={"Offers"}
                        labelColor={"color_262c3d"}
                        placeholder={"Select Offer"}
                        optionList={productOfferList}
                        name={"offer_id"}
                        id={"offer_id"}
                        menuHeight="130px"
                        onChange={(selected) => {
                          setFieldValue("offer_id", selected);
                        }}
                        value={productOfferList?.find(
                          (item) => item.value === values.offer_id
                        )}
                      />
                    </div>
                    <div className=" d-flex justify-content-between">
                      <AdminButton
                        width="50%"
                        height="52px"
                        type="button"
                        color="#FF6F5B"
                        border="1px solid #FF6F5B"
                        onClick={() => ShowClose()}
                      >
                        <span className="m-2">CANCEL</span>
                      </AdminButton>
                      <AdminButton
                        width="50%"
                        height="52px"
                        type="submit"
                        background="#7065E4"
                        border-radius="5px"
                        color="white"
                      >
                        Submit
                      </AdminButton>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </ModalBody>
      </Modal>
      <ChangeSaved show={showSuccessPopup} title={showSuccessMsg} />
      <ErrorPopup
        show={showErrorPopup}
        title={showErrorMsg}
        handleClose={closeErrorPopup}
      />
    </>
  );
};

export default AddProductModal;
